import React, { useState } from "react";
import styles from './Report.module.css';
import HeaderNav from '../../Components/Dahboard Header/HeaderNav/HeaderNav';
import { useLocation } from 'react-router-dom';
import { Eye, Edit, Trash } from 'lucide-react';
import searchicon from "../../Assets/searchicon.png";
import filter from "../../Assets/filter.png";
import mail from "../../Assets/mail.png";
import call from "../../Assets/call.png";
import Footer from "../../Components/Footer/Footer";
import { Link } from "react-router-dom";
import Payments from "../Payments/Payments";
import Reportss from "../Reportss/Reportss";
import profitAndLossImg from "../../Assets/profitandlossfirst.png";
import balanceSheetImg from "../../Assets/balancesheetimg.png";
import cashflowimg from "../../Assets/cashflowimg.png";
const Report = () => {
    const location = useLocation();
    const data = [
        { Invoice: 'REC-001', Customer: 'Dangote Group', InvoiceDate: '2025-01-15', duedate: '2023-01-15', originalamount: '$20000', outstanding: '$200', daysOverdue: '-', status: 'Paid' },
        { Invoice: 'REC-001', Customer: 'Dangote Group', InvoiceDate: '2025-01-15', duedate: '2023-01-15', originalamount: '$20000', outstanding: '$200', daysOverdue: '-', status: 'Pending' },
        { Invoice: 'REC-001', Customer: 'Dangote Group', InvoiceDate: '2025-01-15', duedate: '2023-01-15', originalamount: '$20000', outstanding: '$200', daysOverdue: '11', status: 'Paid' },
        { Invoice: 'REC-001', Customer: 'Dangote Group', InvoiceDate: '2025-01-15', duedate: '2023-01-15', originalamount: '$20000', outstanding: '$200', daysOverdue: '-', status: 'Pending' },
        { Invoice: 'REC-001', Customer: 'Dangote Group', InvoiceDate: '2025-01-15', duedate: '2023-01-15', originalamount: '$20000', outstanding: '$200', daysOverdue: '-', status: 'Paid' },
        { Invoice: 'REC-001', Customer: 'Dangote Group', InvoiceDate: '2025-01-15', duedate: '2023-01-15', originalamount: '$20000', outstanding: '$200', daysOverdue: '-', status: 'Pending' },

    ];
    const profitAndLossIcon =
        "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAFsAAABhCAYAAAC5191SAAAACXBIWXMAABYlAAAWJQFJUiTwAAAAAXNSR0IArs4c6QAAAARnQU1BAACxjwv8YQUAAAR7SURBVHgB7d3PaxxlGMDx53l3ZyBNAilKMfhrFzRBUEjrP5DQinixFsHSUwk9qlQP6jEtePPQLuhRTU8qCNUePCnpRfCiXfAgZC1ZrbI9KF1IbDSTeV/n2bB1N2YyMzvzPvt283wOu7M/hsCXd999dzfwAgg2CAO4YdamxgOvYpSuIKgpOCDQmCZdb5S360ex2oaMUsde3fptrlQqndRgXkKDc3DAGTR1BKzrMKzN+I/U05yTGLsR3JpHLC9Fh/Mg4lzXOnwzKfq+sW+Gty8ZY94AkYpBvLyhNi/GTTF7xv5ps1XxfXPVyHSRWRS0uRXAwlNj0809Huu3ExpWjIEKiIHEBVe7nyih8zMAFd+DFVq19d7fF3tnjpbQRaDgk+HYx7333ZtGaGmnVOkGiEKFoE/Nlh/+go7vjexoDX0VROHKoC51jzuxaS0t04cdNJ00gtY8HXdiI/pnQViDCEuda7q4GbbWZGTbhO310mYV5Y2RRzSYF5RSWAFhnzFzCjVWQNiHZkrp6AKEddEU8rgCwUZiM5LYjCQ2I4nNSGIzktiMJDYjic1IYjOS2IwkNiOJzUhiM5LYjCQ2I4nNSGIzKsOIav31R6bnT/iHYNI7BDaNXGyK/No372WOTU7PnIDzz54BW0ZuGqn98OlAoclnq1/D6p1fwZaRiz09/gDksRFsgi0jN428MvscNO7cikb3n7HPWd+6G0W9C9xGLvb0+IPw/vG3Yx/vzunDiH2gln553jyL4HTs9QJH37BDEydjU5CXr70Dz3/+OtS+/wTyigt97umTcOzILHBxLvbuMLQce/e7j2BQ+4U+98yLwMmp2HFhvlr7dqDgLoUmzsROmlOzBnctNHEidlyYiV3fVaQN7mJoMvTY+4W58sISPBStm3slBXc1NBlq7KQw9AHlg+NvpQ7ucmgytNhpw6QNPmjoJw8/2nd7whsDW4YSO2uYpOB5RjR9l0Jrbfob54+dgZnDj4Et2Ah+v4ColoBJnjB0zqvRubdTfAp0ZeroQoRl1pGdd06NG+G7uRa6iy12UW9eScFdDU1YYhe9SogL7nJoYj22reVYN3jvm5vLoYn1Hw8+/PGatXVv0g8FrrE+sif9/nWr6y91m6yP7N7fBOn49OwJOKisx77fXuo2yb+fMZLYjCQ2I4nNSGIzktiMJDYjic1IYjOS2IwkNiOJzUhiM5LYjCQ2I4nNSGIzktiMJDYjic1IKYOZN5EU2Wmtf1GhkthcFOgw1S6dIh+NUFeeFzQRZHTbpgNVV1Wstg0YGd0WGcQ67Q25s92VNl+CsMaY7Rpdd2Ir759lmUpswXYYlK7TUSc2TSXR0uQiiMIZY2rd7WX79vD9ebu1ArLld5GaT5Snq90bfZ8ggwAWZTopTtRzofd2X2wa7qFWCxK8EIuJu1PP+EfqEjyPTrfFaPpY/t8jcafQ/uueDysgm3Jm0dS6dIoG7F4PYtLZjaB1ARWclej7wTatOjbKf18+Gq3sYp8FKdAoL3kwr2gvWon+H4Sm0XAlKXLXv3RsRfTrVD0JAAAAAElFTkSuQmCC";
    const pageMap = {
        '/dashboard': 'Dashboard',
        '/transactions': 'Transactions',
        '/accounts': 'Accounting',
        '/reports': 'Reports',
        '/banking': 'Banking',
        '/settings': 'Settings',
    };
    const reportData = [
        {
            title: "Income Statement",
            description: "Income statement showing revenue and expenses over a period",
            icon: profitAndLossImg, // ✅ using imported image
            highlight: false,
        },
        {
            title: 'Balance Sheet',
            description: 'Statement of financial position at a specific date',
            icon: balanceSheetImg, // ✅ using imported image
            highlight: false
        },
        {
            title: 'Cash Flow Statement',
            description: 'Track cash receipts and payments over time',
            icon: cashflowimg, // ✅ using imported image
            highlight: false
        },
        {
            title: 'Trial Balance',
            description: 'List of all accounts with their debit and credit balances',
            icon: cashflowimg,
            highlight: false
        },
        {
            title: 'General Ledger',
            description: 'Track cash receipts and payments over time',
            icon: cashflowimg, // ✅ using imported image
            highlight: false
        },
        {
            title: 'Balance',
            description: 'List of all accounts with their debit and credit balances',
            icon: cashflowimg,
            highlight: false
        }
    ];
    const custormerData = [
        {
            title: 'Sales Summary',
            description: 'Overview of sales performance by period',
            icon: profitAndLossImg,
            highlight: false
        },
        {
            title: 'Customer Statement',
            description: 'Detailed account statement for individual customers',
            icon: cashflowimg,
            highlight: false
        },
        {
            title: 'Invoice Register',
            description: 'Complete list of all invoices with status',
            icon: cashflowimg,
            highlight: false
        },
        {
            title: 'Sales by Product',
            description: 'Sales performance breakdown by product or service',
            icon: balanceSheetImg,
            highlight: false
        }
    ];
    const purchaseData = [
        {
            title: 'Purchase Summary',
            description: 'Overview of purchase transactions and trends',
            icon: profitAndLossImg,
            highlight: false
        },
        {
            title: 'Supplier Statement',
            description: 'Account statement for individual suppliers',
            icon: cashflowimg,
            highlight: false
        },
        {
            title: 'Purchase Register',
            description: 'Complete list of all purchase transactions',
            icon: balanceSheetImg,
            highlight: false
        },
        {
            title: 'Expense Analysis',
            description: 'Detailed breakdown of expenses by category',
            icon: profitAndLossImg,
            highlight: false
        }
    ];
    return (
        <div>
            <HeaderNav activePage={pageMap[location.pathname]} />

            <div className={styles.Container}>
                <div className={styles.actions}>
                    <button className={styles.btns}>New Sales Invoice</button>
                    <button className={styles.btns}>New Purchase Invoice</button>
                    <button className={styles.btns}>All Invoices</button>
                    <button className={`${styles.btns} ${styles.greens}`}>Product & Services</button>
                </div>

                <header className={styles.Header}>
                    <div className={styles.left}>
                        <h2 className={styles.Title}>Business Report</h2>
                        <h1 className={styles.Titles}>
                            Generate comprehensive financial and business insights
                        </h1>
                    </div>
                    <div className={styles.right}>
                        <h2 className={styles.Title}>28</h2>
                        <h1 className={styles.Titles}>
                            Reports this month
                        </h1>
                    </div>

                </header>

                <div className={styles.entrjj}>
                    <div className={styles.allkads}>
                        <div className={styles.thrdkad}>
                            <div className={styles.kad}>
                                <p className={styles.kdptg}>Available Reports</p>
                                <p className={styles.kdptg1}>24</p>
                                <div className={styles.rvnue}>
                                    <p className={styles.skaltxt}>Ready to generate</p>
                                </div>
                            </div>
                        </div>
                        <div className={styles.frtkad}>
                            <div className={styles.kad}>
                                <p className={styles.kdptg}>Generated this month</p>
                                <p className={styles.kdptg2}>21</p>
                                <div className={styles.rvnue}>
                                    <p className={styles.skaltxt}>+15% from last month</p>
                                </div>
                            </div>
                        </div>
                        <div className={styles.fiftkad}>
                            <div className={styles.kad}>
                                <p className={styles.kdptg}>Custom Reports</p>
                                <p className={styles.kdptg3}>3</p>
                                <div className={styles.rvnue}>
                                    <p className={styles.skaltxt}>User created</p>
                                </div>
                            </div>
                        </div>
                        <div className={styles.frstkad}>
                            <div className={styles.kad}>
                                <p className={styles.kdptg}>Scheduled Reports</p>
                                <p className={styles.kdptg4}>5</p>
                                <div className={styles.rvnue}>
                                    <p className={styles.skaltxt}>Auto generated</p>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>


                <div className={styles.firstCardDiv}>
                    <div className={styles.topText}>
                        <div className={styles.leftText}>
                            <h3>Financial Reports</h3>
                            <p>Core financial statements and analysis</p>
                        </div>
                        <div className={styles.rightText}>
                            <p className={styles.btn}>4 reports</p>
                        </div>
                    </div>
                    <hr className={styles.sectionDivider} />  {/* <-- Add this line */}

                    <div className={styles.reportFlex}>
                        {reportData.map((report, index) => (
                            <div
                                key={index}
                                className={`${styles.reportCard} ${report.highlight ? styles.highlighted : ''}`}
                            >
                                <div className={styles.reportHeader}>
                                    <div className={styles.icon}>
                                        {typeof report.icon === 'string' && report.icon.startsWith('data:image') ? (
                                            <img src={report.icon} alt={report.title} style={{ width: '32px', height: '32px' }} />
                                        ) : typeof report.icon === 'string' && report.icon.includes('/') ? (
                                            <img src={report.icon} alt={report.title} style={{ width: '32px', height: '32px' }} />
                                        ) : (
                                            <span style={{ fontSize: '32px' }}>{report.icon}</span>
                                        )}
                                    </div>
                                    <span className={styles.tag}>Monthly</span>
                                </div>

                                <h3>{report.title}</h3>
                                <p>{report.description}</p>
                                <p className={styles.last}>Last: 2 days ago</p>

                                {report.title === 'Income Statement' ? (
                                    <Link to="/reportss" className={styles.reportLink}>
                                        <button className={styles.reportBtn}>Generate Report</button>
                                    </Link>
                                ) : report.title === 'Balance Sheet' ? (
                                    <Link to="/balancesheet">
                                        <button className={styles.reportBtn}>Generate Report</button>
                                    </Link>
                                ) : report.title === 'Cash Flow Statement' ? (
                                    <Link to="/cashflow">
                                        <button className={styles.reportBtn}>Generate Report</button>
                                    </Link>
                                ) : report.title === 'Trial Balance' ? (
                                    <Link to="/reports/trailbalance">
                                        <button className={styles.reportBtn}>Generate Report</button>
                                    </Link>
                                ) : report.title === 'General Ledger' ? (
                                    <Link to="/report/general-ledger">
                                        <button className={styles.reportBtn}>Generate Report</button>
                                    </Link>
                                ) : report.title === 'Balance' ? (
                                    <Link to="/reports/trailbalance">
                                        <button className={styles.reportBtn}>Generate Report</button>
                                    </Link>
                                ) : (
                                    <button className={styles.reportBtn}>Generate Report</button>
                                )}
                            </div>
                        ))}
                    </div>

                </div>

                <div className={styles.secondCardDiv}>
                    <div className={styles.topText}>
                        <div className={styles.leftText}>
                            <h3>Sales & Customer Reports</h3>
                            <p>Track sales performance and customer relationships</p>
                        </div>
                        <div className={styles.rightText}>
                            <p className={styles.btn}>4 reports</p>
                        </div>
                    </div>
                    <hr className={styles.sectionDivider} />  {/* <-- Add this line */}

                    <div className={styles.reportFlex}>
                        {custormerData.map((report, index) => (
                            <div
                                key={index}
                                className={`${styles.reportCard} ${report.highlight ? styles.highlighted : ''}`}
                            >
                                <div className={styles.reportHeader}>
                                    <div className={styles.icon}>
                                        <img src={report.icon} alt={report.title} style={{ width: '32px', height: '32px' }} />
                                    </div>
                                    <span className={styles.tag}>Monthly</span>
                                </div>
                                <h4>{report.title}</h4>
                                <p>{report.description}</p>
                                <p className={styles.last}>Last: 2 days ago</p>

                                {report.title === 'Sales Summary' ? (
                                    <Link to="/sales-summary">
                                        <button className={styles.reportBtn}>Generate Report</button>
                                    </Link>
                                ) : report.title === 'Customer Statement' ? (
                                    <Link to="/customer-statement">
                                        <button className={styles.reportBtn}>Generate Report</button>
                                    </Link>
                                ) : report.title === 'Invoice Register' ? (
                                    <Link to="/invoice-register">
                                        <button className={styles.reportBtn}>Generate Report</button>
                                    </Link>
                                ) : report.title === 'Sales by Product' ? (
                                    <Link to="/sales-by-product">
                                        <button className={styles.reportBtn}>Generate Report</button>
                                    </Link>
                                ) : (
                                    <button className={styles.reportBtn}>Generate Report</button>
                                )}
                            </div>
                        ))}
                    </div>
                </div>

                <div className={styles.thirdCardDiv}>
                    <div className={styles.topText}>
                        <div className={styles.leftText}>
                            <h3>Purchase & Supplier Reports</h3>
                            <p>Monitor purchasing activities and supplier relationships</p>
                        </div>
                        <div className={styles.rightText}>
                            <p className={styles.btn}>4 reports</p>
                        </div>
                    </div>
                    <hr className={styles.sectionDivider} />  {/* <-- Add this line */}

                    <div className={styles.reportFlex}>
                        {purchaseData.map((report, index) => (
                            <div
                                key={index}
                                className={`${styles.reportCard} ${report.highlight ? styles.highlighted : ''}`}
                            >
                                <div className={styles.reportHeader}>
                                    <div className={styles.icon}>
                                        <img src={report.icon} alt={report.title} style={{ width: '32px', height: '32px' }} />
                                    </div>
                                    <span className={styles.tag}>Monthly</span>
                                </div>
                                <h4>{report.title}</h4>
                                <p>{report.description}</p>
                                <p className={styles.last}>Last: 2 days ago</p>
                                <button className={styles.reportBtn}>Generate Report</button>
                            </div>
                        ))}

                    </div>
                </div>
            </div>
            <Footer />

        </div >
    );
};

export default Report;
